export const OnboardingErrors = {
  EMAIL_ALREADY_IN_USE: "auth/email-already-in-use",
  REQUIRES_RECENT_LOGIN: "auth/requires-recent-login",
} as const;
export const OnboardingErrorMessages = {
  [OnboardingErrors.EMAIL_ALREADY_IN_USE]: "Credentials already exist, please try again [email]",
  [OnboardingErrors.REQUIRES_RECENT_LOGIN]: "Authentication Failed, please try again",
} as const;
